import React, { Component, Fragment } from "react";
import { observer, inject } from "mobx-react";
import {
    Button,
    Checkbox,
    FormControlLabel,
    Menu, 
    MenuItem, 
    Tooltip
} from "@material-ui/core";

import ResponsiveTable from "../../table/ResponsiveTable";
import TableRowProfile from "../../util/TableRowProfile";

import { ProfileType, ProfileRelationType } from "../../../types/enum";
import EditAgentModal from "../AgentTable/EditAgentModal";
import AcceptRequestModal from "../AgentTable/AcceptRequestModal";
import ConfirmationModal from "../../modal/ConfirmationModal";
import image from "../../../helper/image";

import "./StaffAgentRoster.css";

@inject("agentVenueStore", "templateStore", "userInvitationStore", "profileStore")
@observer
class AgentRosterTable extends Component {
    state = {
        editModalState: false,
        acceptModalState: false,
        deleteRequestModalState: false,
        deleteModalState: false,
        deleteInvitationModalState: false,
        agentVenue: undefined,
        request: undefined,
        actionAnchor: [],
        manageFavouriteActModal: false,
        manageFavouriteAct: null,
        checkedManageFavouriteAct: false,
        manageManageSocial: null,
        checkedManageSocial: false,
        manageManageSocialModal: false
    };

    isTableMounted = false;

    componentDidMount() {
        this.isTableMounted = true;
    }

    componentWillUnmount() {
        this.isTableMounted = false;
    }

    pendingColumns = [
        { key: "venue", label: "Venue" },
        { key: "agent", label: "Agent" },
        { key: "bookingDay", label: "Booking Days" },
        { key: "status", label: "Status" },
        { key: "action", label: "" }
    ];

    mapBookingDay = data => {
        var bookingDay = "";

        if (data?.monday) {
            bookingDay += "Mon, ";
        }
        if (data?.tuesday) {
            bookingDay += "Tue, ";
        }
        if (data?.wednesday) {
            bookingDay += "Wed, ";
        }
        if (data?.thursday) {
            bookingDay += "Thu, ";
        }
        if (data?.friday) {
            bookingDay += "Fri, ";
        }
        if (data?.saturday) {
            bookingDay += "Sat, ";
        }
        if (data?.sunday) {
            bookingDay += "Sun, ";
        }

        return bookingDay.substr(0, bookingDay.length - 2);
    };

    getBookingDaysArray = data => {
        const days = [];
        if (data?.monday) days.push({ day: "Mon", active: true });
        else days.push({ day: "Mon", active: false });
        if (data?.tuesday) days.push({ day: "Tue", active: true });
        else days.push({ day: "Tue", active: false });
        if (data?.wednesday) days.push({ day: "Wed", active: true });
        else days.push({ day: "Wed", active: false });
        if (data?.thursday) days.push({ day: "Thu", active: true });
        else days.push({ day: "Thu", active: false });
        if (data?.friday) days.push({ day: "Fri", active: true });
        else days.push({ day: "Fri", active: false });
        if (data?.saturday) days.push({ day: "Sat", active: true });
        else days.push({ day: "Sat", active: false });
        if (data?.sunday) days.push({ day: "Sun", active: true });
        else days.push({ day: "Sun", active: false });
        return days;
    };

    handleToggleManage = () => {
        const actingProfileId = this.props.profileId;
        if (!this.isCurrentProfile(actingProfileId)) return;
        this.props.templateStore.showLoadingScreen();
        return this.props.agentVenueStore.updateManagePermision(this.state.checkedManageFavouriteAct, this.state.manageFavouriteAct.id).then(() => {
            if (!this.isCurrentProfile(actingProfileId)) return;
            this.closeManageFavouriteActModal()
        }).finally(() => this.props.templateStore.hideLoadingScreen());
    };

    handleToggleManageSocialPost = (checked, data) => {
        const actingProfileId = this.props.profileId;
        if (!this.isCurrentProfile(actingProfileId)) return;
        this.props.templateStore.showLoadingScreen();
        return this.props.agentVenueStore.handleToggleManageSocialPost(this.state.checkedManageSocial, this.state.manageManageSocial.id).then(() => {
            if (!this.isCurrentProfile(actingProfileId)) return;
            this.closeManageSocialModal()
        }).finally(() => this.props.templateStore.hideLoadingScreen());
    };

    openEditModal = agentVenue => {
        const actingProfileId = this.props.profileId;
        this.setState(
            {
                ...this.state,
                editModalState: true
            },
            () => {
                if (this.isCurrentProfile(actingProfileId)) {
                    this.props.agentVenueStore.setEditedAgentVenue(agentVenue);
                }
            }
        );
    };

    closeEditModal = () => {
        const actingProfileId = this.props.profileId;
        this.setState(
            {
                ...this.state,
                editModalState: false
            },
            () => {
                if (this.isCurrentProfile(actingProfileId)) {
                    this.props.agentVenueStore.setEditedAgentVenue(undefined);
                }
            }
        );
    };

    openAcceptModal = request => {
        this.setState({
            ...this.state,
            acceptModalState: true,
            request: request
        });
    };

    closeAcceptModal = () => {
        this.setState({
            ...this.state,
            acceptModalState: false
        });
    };

    handleDelete = () => {
        const actingProfileId = this.props.profileId;
        if (!this.isCurrentProfile(actingProfileId)) return;
        this.props.templateStore.showLoadingScreen();
        return this.props.agentVenueStore.deleteAgentVenue(this.state.agentVenue.id).then(() => {
            if (!this.isCurrentProfile(actingProfileId)) return;
            this.props.templateStore.openSnackbar("Agent has been removed.");
            this.closeDeleteModal();
        }).finally(() => this.props.templateStore.hideLoadingScreen());
    };

    handleDeleteRequest = () => {
        const actingProfileId = this.props.profileId;
        if (!this.isCurrentProfile(actingProfileId)) return;
        this.props.templateStore.showLoadingScreen();
        return this.props.agentVenueStore.deleteRequestByStaff(this.state.request).then(() => {
            if (!this.isCurrentProfile(actingProfileId)) return;
            this.props.templateStore.openSnackbar("Agent request has been removed.");
            this.closeDeleteModal();
        }).finally(() => this.props.templateStore.hideLoadingScreen());
    };

    handleDeleteInvitation = () => {
        const actingProfileId = this.props.profileId;
        const invitation = this.state.request;
        if (!this.isCurrentProfile(actingProfileId)) return;
        this.props.templateStore.showLoadingScreen();
        return this.props.userInvitationStore.deleteInvitation(invitation).then(() => {
            if (!this.isCurrentProfile(actingProfileId)) return;
            return this.props.userInvitationStore.getMyUserInvitation(
                ProfileRelationType.AgentVenue.ordinal,
                actingProfileId
            ).then(() => {
                if (!this.isCurrentProfile(actingProfileId)) return;
                this.props.templateStore.openSnackbar("Agent invitation has been removed.");
                this.closeDeleteModal();
            });
        }).finally(() => this.props.templateStore.hideLoadingScreen());
    };

    openDeleteModal = data => {
        this.setState({
            ...this.state,
            deleteModalState: true,
            agentVenue: data
        });
    };

    openDeleteRequestModal = data => {
        this.setState({
            ...this.state,
            deleteRequestModalState: true,
            request: data
        });
    };

    openDeleteInvitationModal = data => {
        this.setState({
            ...this.state,
            deleteInvitationModalState: true,
            request: data
        });
    };

    closeDeleteModal = () => {
        this.setState({
            ...this.state,
            deleteRequestModalState: false,
            deleteModalState: false,
            deleteInvitationModalState: false,
            agentVenue: undefined,
            request: undefined
        });
    };

    openManageSocialModal = (checked,data) => {
        this.setState({
            ...this.state,
            manageManageSocial: data,
            checkedManageSocial: checked,
            manageManageSocialModal: true
           
        });
    };

    closeManageSocialModal = () => {
        this.setState({
            ...this.state,
            manageManageSocial: null,
            checkedManageSocial: false,
            manageManageSocialModal: false
        });
    };

    openManageFavouriteActModal = (checked,data) => {
        this.setState({
            ...this.state,
            manageFavouriteActModal: true,
            manageFavouriteAct: data,
            checkedManageFavouriteAct: checked
           
        });
    };

    closeManageFavouriteActModal = (checked, data) => {
        this.setState({
            ...this.state,
            manageFavouriteAct: null,
            checkedManageFavouriteAct: false,
            manageFavouriteActModal: false
        });
    };

    isCurrentActor = profileId => {
        if (profileId == null) return false;
        const currentProfileId = this.props.profileStore.getCurrentProfile()?.id;
        return String(profileId) === String(this.props.profileId) &&
            String(profileId) === String(currentProfileId);
    };

    isCurrentProfile = profileId => this.isTableMounted && this.isCurrentActor(profileId);

    handleAcceptRefreshError = error => {
        const actingProfileId = this.props.profileId;
        if (!this.isCurrentActor(actingProfileId)) return;
        if (this.props.onRefreshError) {
            this.props.onRefreshError(error, actingProfileId);
        }
    };

    normalizeId = id => id === undefined || id === null ? "" : String(id);

    getVenueProfile = request => {
        if (request.primaryProfile?.type === ProfileType.Venue.ordinal) return request.primaryProfile;
        if (request.secondaryProfile?.type === ProfileType.Venue.ordinal) return request.secondaryProfile;
        return undefined;
    };

    getRequestVenueId = request => {
        const venueProfile = this.getVenueProfile(request);
        return this.normalizeId(
            request.venueId ||
            request.venue?.id ||
            venueProfile?.id ||
            (request.primaryProfile?.type === ProfileType.Venue.ordinal ? request.primaryProfileId : request.secondaryProfileId)
        );
    };

    getVisibleAgentVenues = () => {
        const { agentVenues = [] } = this.props.agentVenueStore;
        const { venues, selectedVenueId = "all" } = this.props;
        const selectedId = this.normalizeId(selectedVenueId);
        const authorizedIds = Array.isArray(venues) ? new Set(venues.map(venue => this.normalizeId(venue.id))) : null;

        return agentVenues.filter(agentVenue => {
            const venueId = this.normalizeId(agentVenue.venueId || agentVenue.venue?.id);
            return venueId && (!authorizedIds || authorizedIds.has(venueId)) &&
                (selectedId === "all" || venueId === selectedId);
        });
    };

    getVisiblePendingAgentVenues = () => {
        const { pendingAgentVenues = [] } = this.props.agentVenueStore;
        const { venues, selectedVenueId = "all" } = this.props;
        const selectedId = this.normalizeId(selectedVenueId);
        const authorizedIds = Array.isArray(venues) ? new Set(venues.map(venue => this.normalizeId(venue.id))) : null;

        return pendingAgentVenues.filter(request => {
            const venueId = this.getRequestVenueId(request);
            return venueId && (!authorizedIds || authorizedIds.has(venueId)) &&
                (selectedId === "all" || venueId === selectedId);
        });
    };

    getVisibleInvitations = () => {
        const { invitations = [] } = this.props.userInvitationStore;
        const { venues, selectedVenueId = "all" } = this.props;
        const selectedId = this.normalizeId(selectedVenueId);
        const authorizedIds = Array.isArray(venues) ? new Set(venues.map(venue => this.normalizeId(venue.id))) : null;

        return invitations.filter(invitation => {
            const venueId = this.normalizeId(invitation.venueId || invitation.venue?.id);
            return venueId && (!authorizedIds || authorizedIds.has(venueId)) &&
                (selectedId === "all" || venueId === selectedId);
        });
    };

    getVenueGroups = () => {
        const { venues, selectedVenueId = "all", agentVenueStore } = this.props;
        if (!Array.isArray(venues)) {
            return agentVenueStore.groupedPendingAgentVenues || [];
        }

        const selectedId = this.normalizeId(selectedVenueId);
        const visibleAgentVenues = this.getVisibleAgentVenues();
        return venues
            .filter(venue => selectedId === "all" || this.normalizeId(venue.id) === selectedId)
            .map(venue => ({
                venue: this.normalizeId(venue.id),
                profile: venue,
                data: visibleAgentVenues.filter(agentVenue =>
                    this.normalizeId(agentVenue.venueId || agentVenue.venue?.id) === this.normalizeId(venue.id)
                )
            }))
            .filter(group => selectedId !== "all" || group.data.length > 0);
    };

    setActionAnchor = (element, agentVenueId) => {
        var tempAnchor = [];
        tempAnchor[agentVenueId] = element;
        this.setState({ ...this.state, actionAnchor: tempAnchor });
    };

    unsetActionAnchor = agentVenueId => {
        this.setState({ ...this.state, actionAnchor: [] });
    };

    extractInitialFromName = name => {
        if (!name) {
            return "";
        }
        var split = name.split(" ");
        if (split) {
            var initial = "";
            if (split[0]) {
                initial += split[0].substring(0, 1);
            }
            if (split[1]) {
                initial += split[1].substring(0, 1);
            }
            return initial.toUpperCase();
        }
        return "";
    };

    mapInvitedAgentToRowData = () => {
        return this.getVisibleInvitations().map(data => {
            var row = {};
            const venue = data.venue || (this.props.venues || []).find(option =>
                this.normalizeId(option.id) === this.normalizeId(data.venueId)
            );
            var jsonBookingDay = {};
            try {
                jsonBookingDay = typeof data.additionalData === "string"
                    ? JSON.parse(data.additionalData)
                    : data.additionalData || {};
            } catch (error) {
                jsonBookingDay = {};
            }

            row.venue = <TableRowProfile profileId={venue?.id} name={venue?.fullName} avatarUrl={image.getProfileImage(venue)}/>;

            row.agent = <TableRowProfile avatarUrl={image.getProfileImage(data.agent)} name={`${data.invitedFirstName} ${data.invitedLastName} - ${data.invitedEmail}`}/>;

            row.bookingDay = this.mapBookingDay(jsonBookingDay);

            row.status = "Invited";

            row.style = {
                backgroundColor: "#EEE"
            };
            if(this.props.allowBooking){
                row.action = (
                    <Button size="small" color="primary" onClick={() => this.openDeleteInvitationModal(data)}>
                        Remove
                    </Button>
                );
            }else{
                row.action = (
                    ""
                );
            }
          
            return row;
        });
    };

    mapPendingAgentToRowData = () => {
        return this.getVisiblePendingAgentVenues().map(data => {
            var row = {};
            if(data.id) {
                var jsonBookingDay = {};
                try {
                    jsonBookingDay = typeof data.rules === "string" ? JSON.parse(data.rules) : data.rules || {};
                } catch (error) {
                    jsonBookingDay = {};
                }

                var venue = this.getVenueProfile(data);
                var agent = data.primaryProfile?.type === ProfileType.Agent.ordinal ? data.primaryProfile : data.secondaryProfile;
                row.venue = <TableRowProfile profileId={venue?.id} name={venue?.fullName} avatarUrl={image.getProfileImage(venue)} />;
    
                row.agent = <TableRowProfile profileId={agent?.id} name={agent?.fullName} avatarUrl={image.getProfileImage(agent)}/>;
    
                row.bookingDay = this.mapBookingDay(jsonBookingDay);
            }


            row.status = "Pending";

            row.style = {
                backgroundColor: "#EEE"
            };
            if(this.props.allowBooking){
                row.action =
                data.primaryProfile && data.primaryProfile.type !== ProfileType.Venue.ordinal ? (
                    <Button size="small" color="primary" className="btn-venue-request" onClick={() => this.openAcceptModal(data)}>
                        View Request
                    </Button>
                ) : (
                    <Button size="small" color="primary" onClick={() => this.openDeleteRequestModal(data)}>
                        Remove
                    </Button>
                );
            }else{
                row.action = ("")
            }
          

            return row;
        });
    };

    renderBookingDays = (agentVenue) => {
        let bookingData = null;
        
        if (agentVenue?.rules) {
            if (typeof agentVenue.rules === 'string') {
                try {
                    bookingData = JSON.parse(agentVenue.rules);
                } catch (e) {
                    bookingData = null;
                }
            } else if (typeof agentVenue.rules === 'object') {
                bookingData = agentVenue.rules;
            }
        }
        
        if (!bookingData) {
            if (agentVenue?.monday !== undefined || agentVenue?.tuesday !== undefined) {
                bookingData = agentVenue;
            } else {
                return <span className="day-chip inactive">No days set</span>;
            }
        }
        
        const days = this.getBookingDaysArray(bookingData);
        const activeDays = days.filter(d => d.active);
        
        if (activeDays.length === 0) {
            return <span className="day-chip inactive">No days set</span>;
        }
        
        return (
            <div className="day-chips">
                {activeDays.map(d => (
                    <span key={d.day} className="day-chip">{d.day}</span>
                ))}
            </div>
        );
    };

    renderContactChips = (agent) => {
        const phone = agent?.contactPhone || agent?.phone;
        const email = agent?.email || agent?.contactEmail;

        return (
            <div className="contact-chips">
                {phone ? (
                    <a href={`tel:${phone}`} className="contact-chip phone">
                        <i className="fa fa-phone"></i> {phone}
                    </a>
                ) : (
                    <span className="contact-chip empty">
                        <i className="fa fa-phone"></i> No phone
                    </span>
                )}
                {email ? (
                    <a href={`mailto:${email}`} className="contact-chip email">
                        <i className="fa fa-envelope"></i> {email}
                    </a>
                ) : (
                    <span className="contact-chip empty">
                        <i className="fa fa-envelope"></i> No email
                    </span>
                )}
            </div>
        );
    };

    renderAgentRow = (data) => {
        const { allowBooking } = this.props;

        return (
            <tr key={data.id}>
                <td data-label="Agent">
                    <div className="agent-cell">
                        {data.agent?.profileImage ? (
                            <img 
                                src={image.getProfileImage(data.agent)} 
                                alt={data.agent?.fullName} 
                                className="agent-cell-avatar"
                            />
                        ) : (
                            <div className="agent-cell-avatar">
                                {this.extractInitialFromName(data.agent?.fullName)}
                            </div>
                        )}
                        <div className="agent-cell-info">
                            <strong>{data.agent?.fullName || data.agent?.profileName}</strong>
                        </div>
                    </div>
                </td>
                <td data-label="Contact">
                    {this.renderContactChips(data.agent)}
                </td>
                <td data-label="Booking Days">
                    {this.renderBookingDays(data)}
                </td>
                <td data-label="Permissions">
                    <div className="permissions-cell">
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={data.manage}
                                    onChange={(e, checked) => allowBooking ? this.openManageFavouriteActModal(checked, data) : null}
                                    value={data.manage}
                                    disabled={!allowBooking}
                                    color="primary"
                                />
                            }
                            label="Manage Favourite Acts"
                        />
                        <Tooltip title={data.agent?.agentProPlan ? "" : "Agency needs to be subscribed to the Pro Plan to enable this feature."}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        disabled={!data.agent?.agentProPlan || !allowBooking}
                                        checked={data.manageSocialPost}
                                        onChange={(e, checked) => this.openManageSocialModal(checked, data)}
                                        value={data.manageSocialPost}
                                        color="primary"
                                    />
                                }
                                label={
                                    <span className="permission-label">
                                        Manage Social Posts
                                        {!data.agent?.agentProPlan && <span className="pro-badge">PRO</span>}
                                    </span>
                                }
                            />
                        </Tooltip>
                    </div>
                </td>
                <td data-label="Actions">
                    {allowBooking && (
                        <Fragment>
                            <button 
                                className="action-dropdown-btn"
                                onClick={e => this.setActionAnchor(e.currentTarget, data.id)}
                            >
                                Actions <i className="fa fa-caret-down"></i>
                            </button>
                            {data.id && (
                                <Menu
                                    open={this.state.actionAnchor[data.id] != null}
                                    onClose={() => this.unsetActionAnchor(data.id)}
                                    anchorEl={this.state.actionAnchor[data.id]}
                                >
                                    <MenuItem 
                                        button
                                        className="action-menu-item-primary"
                                        component="a"
                                        href={`/profile/${data.agent?.id}`}
                                        target="_blank"
                                    >
                                        <i className="fa fa-user action-menu-icon"></i>
                                        View Profile
                                    </MenuItem>
                                    <MenuItem 
                                        button
                                        onClick={() => {
                                            this.unsetActionAnchor(data.id);
                                            this.openEditModal(data);
                                        }}
                                    >
                                        <i className="fa fa-pencil action-menu-icon"></i>
                                        Edit Booking Days
                                    </MenuItem>
                                    <MenuItem 
                                        button
                                        className="action-menu-item-danger"
                                        onClick={() => {
                                            this.unsetActionAnchor(data.id);
                                            this.openDeleteModal(data);
                                        }}
                                    >
                                        <i className="fa fa-trash action-menu-icon"></i>
                                        Remove Agent
                                    </MenuItem>
                                </Menu>
                            )}
                        </Fragment>
                    )}
                </td>
            </tr>
        );
    };

    renderVenueCard = (venue) => {
        const venueData = venue.profile || venue.data[0]?.venue;
        const agentCount = venue.data.length;

        return (
            <article key={venueData?.id} className="venue-card">
                <header className="venue-card-header">
                    <div className="venue-card-meta">
                        {venueData?.profileImage ? (
                            <img 
                                src={image.getProfileImage(venueData)} 
                                alt={venueData?.fullName} 
                                className="venue-card-avatar"
                            />
                        ) : (
                            <div className="venue-card-avatar">
                                {this.extractInitialFromName(venueData?.fullName)}
                            </div>
                        )}
                        <div className="venue-card-info">
                            <h2>{venueData?.fullName || venueData?.profileName}</h2>
                            <span>{venueData?.city || venueData?.suburb}</span>
                        </div>
                    </div>
                    <div className="venue-card-stats">
                        <span className="agent-count-badge">
                            {agentCount} {agentCount === 1 ? 'Agent' : 'Agents'}
                        </span>
                    </div>
                </header>
                
                {agentCount > 0 ? <table className="staff-agent-table">
                    <thead>
                        <tr>
                            <th style={{ width: "22%" }}>Agent</th>
                            <th style={{ width: "18%" }}>Contact</th>
                            <th style={{ width: "15%" }}>Booking Days</th>
                            <th style={{ width: "30%" }}>Permissions</th>
                            <th style={{ width: "15%" }}>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {venue.data.map(data => this.renderAgentRow(data))}
                    </tbody>
                </table> : (
                    <p className="venue-empty-state">No agents are assigned to this venue yet.</p>
                )}
            </article>
        );
    };

    render() {
        const pendingRows = [
            ...this.mapInvitedAgentToRowData(),
            ...this.mapPendingAgentToRowData()
        ];
        const groupedVenues = this.getVenueGroups();
        const selectedVenue = (this.props.venues || []).find(venue =>
            this.normalizeId(venue.id) === this.normalizeId(this.props.selectedVenueId)
        );
        const isVenueSelected = this.props.selectedVenueId && this.props.selectedVenueId !== "all";
        const emptyMessage = this.props.venues?.length === 0
            ? "No venues are available for this staff profile."
            : isVenueSelected
                ? `No agents are assigned to ${selectedVenue?.fullName || selectedVenue?.profileName || "this venue"} yet.`
                : "No agents assigned to your venues yet.";

        return (
            <Fragment>
                {pendingRows.length > 0 && (
                    <Fragment>
                        <ResponsiveTable
                            columns={this.pendingColumns}
                            rows={pendingRows}
                            showToolbar={true}
                            title="Pending Requests & Invitations"
                            pagination={pendingRows.length > 5}
                        />
                        <br />
                    </Fragment>
                )}

                <div className="staff-agent-roster-container">
                    {groupedVenues.map(venue => this.renderVenueCard(venue))}
                    
                    {groupedVenues.length === 0 && (
                        <div className="venue-empty-state">
                            <i className="fa fa-users"></i>
                            <p>{emptyMessage}</p>
                        </div>
                    )}
                </div>

                <EditAgentModal open={this.state.editModalState} onClose={this.closeEditModal} />
                <AcceptRequestModal
                    open={this.state.acceptModalState}
                    onClose={this.closeAcceptModal}
                    onRefreshError={this.handleAcceptRefreshError}
                    profileId={this.props.profileId}
                    request={this.state.request}
                    isStaff={true}
                />

                <ConfirmationModal
                    title="Delete Agent"
                    open={this.state.deleteInvitationModalState}
                    message="Are you sure you want to delete this agent?"
                    closeHandler={this.closeDeleteModal}
                    confirmationHandler={this.handleDeleteInvitation}
                    confirmationLabel="Delete"
                />

                <ConfirmationModal
                    title="Delete Agent"
                    open={this.state.deleteRequestModalState}
                    message="Are you sure you want to delete this agent?"
                    closeHandler={this.closeDeleteModal}
                    confirmationHandler={this.handleDeleteRequest}
                    confirmationLabel="Delete"
                />

                <ConfirmationModal
                    title="Confirmation"
                    open={this.state.manageFavouriteActModal}
                    message={this.state.checkedManageFavouriteAct ? `Are you sure you want to allow ${this.state.manageFavouriteAct?.agent?.profileName} to manage your venue favourite acts?` : `${this.state.manageFavouriteAct?.agent?.profileName} will no longer be able to manage your venue favourite acts. Would you like to proceed?`}
                    closeHandler={this.closeManageFavouriteActModal}
                    confirmationHandler={this.handleToggleManage}
                    confirmationLabel="Confirm"
                />

                <ConfirmationModal
                    title="Confirmation"
                    open={this.state.manageManageSocialModal}
                    message={this.state.checkedManageSocial ? `Are you sure you want to allow  ${this.state.manageManageSocial?.agent?.profileName} to post to your social media channels?` : `${this.state.manageManageSocial?.agent?.profileName}  will no longer be able to post to your social channels. (Existing scheduled posts will not be impacted by this change). Would you like to proceed?`}
                    closeHandler={this.closeManageSocialModal}
                    confirmationHandler={this.handleToggleManageSocialPost}
                    confirmationLabel="Confirm"
                />

                <ConfirmationModal
                    title="Delete Agent"
                    open={this.state.deleteModalState}
                    message="Are you sure you want to delete this agent?"
                    closeHandler={this.closeDeleteModal}
                    confirmationHandler={this.handleDelete}
                    confirmationLabel="Delete"
                />
            </Fragment>
        );
    }
}

export default AgentRosterTable;
